/**
 * Carrinho lateral: cupom + produto brinde
 * - Cupom só é considerado aplicado se estiver em cart.discount_codes ou discount_applications (cart.js).
 * - Brinde só é adicionado quando: valor >= gift_min_value E cupom do schema presente no cart.
 * - Debug: no console da página defina window.__CART_GIFT_DEBUG = true e recarregue; os logs mostrarão cart, decisão e ação.
 */
(function () {
  'use strict';

  var routes = (typeof window !== 'undefined' && window.theme && window.theme.routes && window.theme.routes.cart) ? window.theme.routes.cart : {};
  var CART_JS = (routes.base || '/cart') + (routes.base && routes.base.indexOf('.js') === -1 ? '.js' : '');
  var CART_ADD = (routes.add || '/cart/add') + (routes.add && routes.add.indexOf('.js') === -1 ? '.js' : '');
  var CART_CHANGE = (routes.change || '/cart/change') + (routes.change && routes.change.indexOf('.js') === -1 ? '.js' : '');
  var SESSION_KEY = 'gift_coupon_applied';

  function getQuickCartEl() {
    return document.querySelector('.quick-cart');
  }

  function getConfig() {
    var el = getQuickCartEl();
    if (!el) return null;
    var min = el.getAttribute('data-gift-min-value');
    var variantId = el.getAttribute('data-gift-variant-id');
    var coupon = el.getAttribute('data-gift-coupon');
    if (!min || !variantId || !coupon) return null;
    return {
      minValue: parseInt(min, 10) || 0,
      minValueCents: (parseInt(min, 10) || 0) * 100,
      variantId: String(variantId),
      couponCode: String(coupon).trim().toUpperCase()
    };
  }

  function getCart() {
    return fetch(CART_JS, { method: 'GET', credentials: 'include' })
      .then(function (r) { return r.json(); });
  }

  /**
   * Verifica se o cupom digitado pelo usuário foi aplicado de fato no carrinho (cart.js).
   * Considera aplicado se: está em discount_codes com applicable === true, ou em cart_level_discount_applications.
   */
  function isCodeApplicableInCart(cart, code) {
    if (!code || !cart) return false;
    var codeUpper = String(code).trim().toUpperCase();
    var discountCodes = cart.discount_codes || [];
    for (var i = 0; i < discountCodes.length; i++) {
      var dc = discountCodes[i];
      var c = (dc.code || '').trim().toUpperCase();
      if (c === codeUpper && dc.applicable === true) return true;
    }
    var applications = cart.discount_applications || cart.cart_level_discount_applications || [];
    for (var j = 0; j < applications.length; j++) {
      var app = applications[j];
      var title = (app.title || '').trim().toUpperCase();
      var appCode = (app.code || '').trim().toUpperCase();
      if (title === codeUpper || appCode === codeUpper) return true;
    }
    return false;
  }

  /**
   * Verifica se o cupom do schema está no carrinho (apenas via cart.js).
   * Só considera aplicado se o código aparecer em discount_codes ou discount_applications.
   * Não usa sessionStorage para evitar adicionar brinde no reload sem cupom no cart.
   */
  function isCouponApplied(cart, config) {
    if (!config) return false;
    var code = config.couponCode;
    var applications = cart.discount_applications || cart.cart_level_discount_applications || [];
    for (var i = 0; i < applications.length; i++) {
      var app = applications[i];
      var title = (app.title || '').trim().toUpperCase();
      var appCode = (app.code || '').trim().toUpperCase();
      if (title === code || appCode === code) return true;
    }
    var discountCodes = cart.discount_codes || [];
    for (var j = 0; j < discountCodes.length; j++) {
      var dc = discountCodes[j];
      var cartCode = (dc.code || '').trim().toUpperCase();
      if (cartCode === code) return true;
    }
    return false;
  }

  function getSubtotalCents(cart) {
    if (cart.original_total_price != null) return cart.original_total_price;
    var sum = 0;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      sum += (items[i].original_line_price || 0);
    }
    return sum;
  }

  function findGiftLine(cart, variantId) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(variantId)) return items[i];
    }
    return null;
  }

  function addGift(variantId) {
    return fetch(CART_ADD, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status === 422) return { ok: false };
      return getCart().then(function (cart) { return { ok: true, cart: cart }; });
    });
  }

  function setQuantity(line, quantity) {
    return fetch(CART_CHANGE, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function removeGift(cart, variantId) {
    var gift = findGiftLine(cart, variantId);
    if (!gift) return Promise.resolve(cart);
    var line = cart.items.indexOf(gift) + 1;
    return setQuantity(line, 0);
  }

  function applyCoupon(code) {
    var url = '/discount/' + encodeURIComponent(code);
    return fetch(url, { method: 'GET', credentials: 'include', redirect: 'follow' });
  }

  function triggerCartRefresh() {
    try {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    } catch (e) {}
  }

  function triggerCartUpdated(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    } catch (e) {}
  }

  var inSync = false;
  var DEBUG = typeof window !== 'undefined' && window.__CART_GIFT_DEBUG;

  function debugLog(cart, config, subtotalOk, couponOk, hasGift, action) {
    if (!DEBUG || !config) return;
    var discountCodes = (cart && cart.discount_codes) ? cart.discount_codes : [];
    var applications = (cart && (cart.discount_applications || cart.cart_level_discount_applications)) || [];
    console.log('[cart-gift-discount]', {
      configCoupon: config.couponCode,
      giftMinValue: config.minValue,
      subtotalCents: cart ? getSubtotalCents(cart) : 0,
      minValueCents: config.minValueCents,
      subtotalOk: subtotalOk,
      couponOk: couponOk,
      hasGift: hasGift,
      cartDiscountCodes: discountCodes,
      cartDiscountApplications: applications,
      action: action
    });
  }

  /**
   * Regras:
   * 1) Cupom do schema deve dar match no cart (discount_codes / discount_applications) – apenas cart.js.
   * 2) Carrinho deve ser >= valor em gift_min_value (schema).
   * 3) Se 1 e 2: garantir que o produto brinde está no carrinho com 1 un; se não estiver, adicionar e atualizar o carrinho.
   * 4) Em qualquer alteração do carrinho (quantidade, remoção, cupom) revalidar e manter carrinho atualizado.
   */
  function validateAndSync() {
    var config = getConfig();
    if (!config) return Promise.resolve();

    if (inSync) return Promise.resolve();
    inSync = true;

    return getCart()
      .then(function (cart) {
        var subtotalCents = getSubtotalCents(cart);
        var subtotalOk = subtotalCents >= config.minValueCents;
        var couponOk = isCouponApplied(cart, config);
        var giftLine = findGiftLine(cart, config.variantId);
        var hasGift = !!giftLine;

        if (subtotalOk && couponOk && !hasGift) {
          debugLog(cart, config, subtotalOk, couponOk, hasGift, 'ADD_GIFT');
          return addGift(config.variantId).then(function (result) {
            if (result && result.ok && result.cart) {
              triggerCartRefresh();
              triggerCartUpdated(result.cart);
            }
            return result && result.cart ? result.cart : getCart();
          });
        }

        if ((!subtotalOk || !couponOk) && hasGift) {
          debugLog(cart, config, subtotalOk, couponOk, hasGift, 'REMOVE_GIFT');
          return removeGift(cart, config.variantId).then(function (newCart) {
            triggerCartRefresh();
            if (newCart) triggerCartUpdated(newCart);
            return newCart;
          });
        }

        if (subtotalOk && couponOk && hasGift && giftLine.quantity !== 1) {
          debugLog(cart, config, subtotalOk, couponOk, hasGift, 'FIX_QUANTITY_1');
          var line = cart.items.indexOf(giftLine) + 1;
          return setQuantity(line, 1).then(function (newCart) {
            triggerCartRefresh();
            if (newCart) triggerCartUpdated(newCart);
            return newCart;
          });
        }

        debugLog(cart, config, subtotalOk, couponOk, hasGift, 'NONE');
        return cart;
      })
      .catch(function (err) {
        console.warn('cart-gift-discount: validateAndSync error', err);
      })
      .then(function () {
        inSync = false;
      });
  }

  var messageErrorTimeout = null;

  function runApplyLogic(applyBtn, input, messageEl) {
    if (!applyBtn || !input || !messageEl) return;

    function showMessage(text, type) {
      messageEl.textContent = text || '';
      messageEl.classList.add(type || '');
      messageEl.classList.remove('hidden');
      if (type === 'success') messageEl.classList.remove('error');
      if (type === 'error') messageEl.classList.remove('success');
    }

    function hideMessage() {
      messageEl.classList.add('hidden');
    }

    function showErrorAndAutoHide(msg) {
      if (messageErrorTimeout) clearTimeout(messageErrorTimeout);
      showMessage(msg, 'error');
      messageErrorTimeout = setTimeout(function () {
        hideMessage();
        messageErrorTimeout = null;
      }, 5000);
    }

    function setLoading(loading) {
      if (loading) applyBtn.classList.add('is-loading');
      else applyBtn.classList.remove('is-loading');
    }

    var code = (input.value || '').trim();
    if (!code) {
      showMessage('Digite um cupom.', 'error');
      return;
    }
    setLoading(true);
    hideMessage();

    var config = getConfig();
    getCart()
      .then(function (cart) {
        var userCodeUpper = code.toUpperCase();
        var isSchemaCoupon = config && (userCodeUpper === config.couponCode);
        var subtotalCents = getSubtotalCents(cart);
        var meetsMin = config && (subtotalCents >= config.minValueCents);
        var hasGift = config && !!findGiftLine(cart, config.variantId);

        function afterApply(updatedCart, addedGift) {
          triggerCartRefresh();
          triggerCartUpdated(updatedCart);
          if (isCodeApplicableInCart(updatedCart, code)) {
            showMessage(addedGift ? 'CUPOM APLICADO. Brinde adicionado.' : 'CUPOM APLICADO.', 'success');
          } else {
            showErrorAndAutoHide('Ainda não atende requisitos ou inválido.');
          }
          return validateAndSync();
        }

        if (isSchemaCoupon && meetsMin && !hasGift) {
          return addGift(config.variantId)
            .then(function (result) {
              if (!result || !result.ok) return Promise.reject(new Error('add_gift_failed'));
              return applyCoupon(code);
            })
            .then(function () { return getCart(); })
            .then(function (updatedCart) { return afterApply(updatedCart, true); });
        }

        if (isSchemaCoupon && meetsMin && hasGift) {
          return applyCoupon(code)
            .then(function () { return getCart(); })
            .then(function (updatedCart) { return afterApply(updatedCart, false); });
        }

        return applyCoupon(code)
          .then(function () { return getCart(); })
          .then(function (updatedCart) { return afterApply(updatedCart, false); });
      })
      .catch(function () {
        showErrorAndAutoHide('Ainda não atende requisitos ou inválido.');
      })
      .then(function () {
        setLoading(false);
      });
  }

  function initDiscountForm() {
    document.addEventListener('click', function (e) {
      var applyBtn = e.target.closest && e.target.closest('[data-discount-apply]');
      if (!applyBtn) return;
      e.preventDefault();
      var quickCart = getQuickCartEl();
      if (!quickCart) return;
      var input = quickCart.querySelector('[data-discount-input]');
      var messageEl = quickCart.querySelector('[data-discount-message]');
      runApplyLogic(applyBtn, input, messageEl);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest && e.target.closest('[data-discount-input]');
      if (!input) return;
      var quickCart = getQuickCartEl();
      var applyBtn = quickCart && quickCart.querySelector('[data-discount-apply]');
      if (applyBtn) applyBtn.click();
    });
  }

  function listen() {
    document.addEventListener('cart:updated', function () {
      setTimeout(validateAndSync, 100);
    });
    document.addEventListener('cart:item-added', function () {
      setTimeout(validateAndSync, 100);
    });
    document.addEventListener('quick-cart:updated', function () {
      setTimeout(validateAndSync, 100);
    });
    document.addEventListener('quick-cart:open', function () {
      setTimeout(validateAndSync, 150);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initDiscountForm();
        setTimeout(validateAndSync, 300);
      });
    } else {
      initDiscountForm();
      setTimeout(validateAndSync, 300);
    }
  }

  listen();
})();
